import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function entryContradictsTradePlanDirectionBuilder({parsedStatusObj}) {
  const user = parsedStatusObj.userDesiredToGoLong;
  const tradePlan = parsedStatusObj.tradePlanGoLong;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        {user ? 'Long' : 'Short'} {user === null ? 'Entry' : 'entry'}{' '}
        contradicts {tradePlan ? 'long' : 'short'} trade plan direction.
      </Body3>
    </td>
  );
}
